// This file was auto generated by resource-sync tools.

import ar_shop_set_web from './ar/shop_set_web.json';
import en_shop_set_web from './en/shop_set_web.json';
import ptBR_shop_set_web from './pt-BR/shop_set_web.json';
import zh_shop_set_web from './zh/shop_set_web.json';
import zhHK_shop_set_web from './zh-HK/shop_set_web.json';
import ar_account_web from './ar/account_web.json';
import en_account_web from './en/account_web.json';
import ptBR_account_web from './pt-BR/account_web.json';
import zh_account_web from './zh/account_web.json';
import zhHK_account_web from './zh-HK/account_web.json';
import ar_marketing_web from './ar/marketing_web.json';
import en_marketing_web from './en/marketing_web.json';
import ptBR_marketing_web from './pt-BR/marketing_web.json';
import zh_marketing_web from './zh/marketing_web.json';
import zhHK_marketing_web from './zh-HK/marketing_web.json';
import ar_b_ad_fe from './ar/b_ad_fe.json';
import en_b_ad_fe from './en/b_ad_fe.json';
import zh_b_ad_fe from './zh/b_ad_fe.json';
import zhHK_b_ad_fe from './zh-HK/b_ad_fe.json';


const resources = {
    // 'namespaces': 
    // [{"localeInfos":[{"locale":"ar","version":311},{"locale":"en","version":278},{"locale":"pt-BR","version":38},{"locale":"zh","version":239},{"locale":"zh-HK","version":242}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"dtu0qybsds","namespaceName":"shop_set_web"}},{"localeInfos":[{"locale":"ar","version":45},{"locale":"en","version":50},{"locale":"pt-BR","version":13},{"locale":"zh","version":48},{"locale":"zh-HK","version":45}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"olipmd4ssu","namespaceName":"account_web"}},{"localeInfos":[{"locale":"ar","version":356},{"locale":"en","version":337},{"locale":"pt-BR","version":35},{"locale":"zh","version":397},{"locale":"zh-HK","version":328}],"i18nConfig":{"apiKey":"dd709595d1344094ae219064ab53f28b","projectId":5,"namespaceId":"2jvsptqql2","namespaceName":"marketing_web"}},{"localeInfos":[{"locale":"ar","version":4},{"locale":"en","version":422},{"locale":"zh","version":340},{"locale":"zh-HK","version":338}],"i18nConfig":{"apiKey":"ec21d67c5e924c3b90533d9ea791a836","projectId":19,"namespaceId":"b3ywlb2ytp","namespaceName":"b_ad_fe"}}],
    'ar': {
        shop_set_web: ar_shop_set_web,
        account_web: ar_account_web,
        marketing_web: ar_marketing_web,
        b_ad_fe: ar_b_ad_fe
    },
    'en': {
        shop_set_web: en_shop_set_web,
        account_web: en_account_web,
        marketing_web: en_marketing_web,
        b_ad_fe: en_b_ad_fe
    },
    'pt-BR': {
        shop_set_web: ptBR_shop_set_web,
        account_web: ptBR_account_web,
        marketing_web: ptBR_marketing_web
    },
    'zh': {
        shop_set_web: zh_shop_set_web,
        account_web: zh_account_web,
        marketing_web: zh_marketing_web,
        b_ad_fe: zh_b_ad_fe
    },
    'zh-HK': {
        shop_set_web: zhHK_shop_set_web,
        account_web: zhHK_account_web,
        marketing_web: zhHK_marketing_web,
        b_ad_fe: zhHK_b_ad_fe
    }
};

export default resources;